export default (path: string) => {
	if (!path.startsWith('/') || !path.endsWith('/')) {
		throw new Error('path must be start or end with "/"');
	}
};
